export default __webpack_public_path__ + "assets/0a14f218dce20b61cf8aec9e1ac0da90.jpg";